import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "../../../../shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  ICON_LIST_FIXED,
  LOCAL_STORAGE,
  PHONE_TRANSLATIONS
} from "../../../../shared/constants/FormConstants";
import ModalTemplate from "../../../../shared/components/ModalTemplate/ModalTemplate.vue";
import { Http } from "@status/codes";
import { OrderTemplate } from "../../models/OrderTemplate";
import AddFieldGroup from "../../../../shared/components/AddFieldGroup/AddFieldGroup.vue";
import { FieldOrder } from "../../models/FieldOrder";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FullSchema } from "../../../../shared/models/FullSchema";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import { TYPE_FIELDS } from "../../../../shared/constants/FormConstants";
import { OrderService } from "../../services/OrderService";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import { ListService } from "@/modules/List/services/ListService";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { ORDER_CONSTANTS, ORDER_ACCESS } from "../../constants/OrderConstants";
import { OrderListDataView } from "../../models/OrderListDataView";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import { ManagedListsService } from "@/shared/services/ManagedListsService";
import {
  MANAGED_LISTS_TYPES,
  GENERAL_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { Icon } from "@/shared/models/Icon";
import { Utils } from "@/shared/utils/utils";
import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import {
  FIELD_GROUP_CONSTANTS,
  INFO_GROUP_CONSTANTS
} from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { FieldGroup } from "@/modules/InfoGroup/models/FieldGroup";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import { MULTIMEDIA_CLEANED } from "@/shared/components/MultimediaManager/constants/MultimediaManagerConstants";
import MultimediaManager from "@/shared/components/MultimediaManager/MultimediaManager.vue";
import { PreventKey } from "@/shared/mixins/mixins";
import { MEDICAL_ORDER_ACCESS } from "@/modules/MedicalOrder/constants/MedicalOrderConstants";
import { OrderForm } from "../../models/OrderForm.model";

@Component({
  name: "SaveOrderField",
  components: {
    ModalTemplate,
    AddFieldGroup,
    FormModalViewer,
    ModifVJsfInput,
    VJsf,
    VuePhoneNumberInput,
    MultimediaManager
  }
})
export default class SaveOrderField extends PreventKey {
  @Inject() orderService!: OrderService;
  @Inject() listService!: ListService;
  @Inject() managedListsService!: ManagedListsService;
  @Prop({ default: false, required: false })
  public isModal!: boolean;

  PAGE_TITLE = ORDER_CONSTANTS.EDIT_TITLE;
  ADD_FIELD_BTN = ORDER_CONSTANTS.BUTTON.ADD_FIELD;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  FIELDS_TITLE = ORDER_CONSTANTS.FIELDS_TITLE;
  DEFAULT_FIELDS = ORDER_CONSTANTS.DEFAULT_FIELDS;
  PREVIEW_BTN = FORM_CONSTANTS.BUTTON.PREVIEW;
  HELP_URL = ORDER_CONSTANTS.LABELS.URL_TEXT;
  HELP_TEXT = ORDER_CONSTANTS.LABELS.HELP_TEXT;
  HELP_ICON = ORDER_CONSTANTS.LABELS.ICON_TEXT;
  STATE_LABEL = ORDER_CONSTANTS.LABELS.STATE;
  DIAG_CODE = ORDER_CONSTANTS.LABELS.DIAG_CODE;
  CANCEL_VALUE = ORDER_CONSTANTS.LABELS.CANCEL_VALUE;
  SERVICE_VALUE = ORDER_CONSTANTS.LABELS.SERVICE_VALUE;
  EVENT = ORDER_CONSTANTS.LABELS.EVENT;
  BILL_TYPE = ORDER_CONSTANTS.LABELS.BILL_TYPE;
  CAMPUS = ORDER_CONSTANTS.LABELS.CAMPUS;
  DESCRIPTION = ORDER_CONSTANTS.LABELS.DESCRIPTION;
  ORDER_TYPE = ORDER_CONSTANTS.LABELS.ORDER_TYPE;
  PRICE_LEVEL = ORDER_CONSTANTS.LABELS.PRICE_LEVEL;
  EXT_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.EXTERNAL_NAME.TEXT;
  EXT_NAME_DATA = ORDER_CONSTANTS.PREVIEW_EXAMPLE.EXTERNAL_NAME.EXAMPLE;
  INT_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.INTERNAL_NAME.TEXT;
  INT_NAME_DATA = ORDER_CONSTANTS.PREVIEW_EXAMPLE.INTERNAL_NAME.EXAMPLE;
  CAT_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.CATEGORY.TEXT;
  CAT_NAME_DATA = ORDER_CONSTANTS.PREVIEW_EXAMPLE.CATEGORY.EXAMPLE;
  CUPS_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.CUPS.TEXT;
  CUPS_NAME_DATA = ORDER_CONSTANTS.PREVIEW_EXAMPLE.CUPS.EXAMPLE;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  DASHBOARD_VISIBLE = ORDER_CONSTANTS.LABELS.DASHBOARD_VISIBLE;
  DASHBOARD_EDITABLE = ORDER_CONSTANTS.LABELS.DASHBOARD_EDITABLE;
  EDITABLE_FIELDS = ORDER_CONSTANTS.EDITABLE_FIELDS;

  cardClass = STYLE_CLASSES.CARD;
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  switchClass = STYLE_CLASSES.SWITCH;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  orderTemplateName = ORDER_CONSTANTS.ORDER_TEMP_TEXT;
  orderTypes = ORDER_CONSTANTS.ORDER_TYPE;

  model = [];
  countriesPreferredList = INFO_GROUP_CONSTANTS.PREFERRED_COUNTRIES;
  translations = PHONE_TRANSLATIONS;

  modalDialogOrder = false;
  clearModel = false;
  modalTitleOrder = "";
  modalTextOrder = "";
  dialogFieldOrder = false;
  dialogPreview = false;
  indexField = -1;
  isEditingOrderField = false;
  orderTemplateForm = false;
  idEditing = "";
  orderTemplateEditing!: OrderTemplate;
  orderSchema: FullSchema = {
    title: "",
    description: "",
    type: "object",
    properties: {},
    required: []
  };
  schema: GroupFullSchema = {
    allOf: [this.orderSchema],
    type: "object"
  };
  phoneSchemaCharged = false;
  phoneTypeList: PhoneSchema[] = [];
  originalFields!: FieldOrder[];
  listData: OrderListDataView = {
    stateList: { data: [] },
    billType: { data: [] },
    campus: { data: [] },
    diagnosticPrimaryCode: { data: [] }
  };
  iconsList = ICON_LIST_FIXED;
  imagesList: string[] = [];
  defaultCountry = "";

  orderForm: OrderForm = {
    helpTxt: "",
    multimediaFile: { ...MULTIMEDIA_CLEANED },
    iconUrl: "",
    fieldsOrder: [],
    orderTempRef: "",
    visibleDashboardFields: [],
    editableDashboardFields: []
  };
  editComparationStr = "";
  invalidEdit = false;

  mounted() {
    this.load();
  }

  load() {
    this.getTemplate();
    this.phoneSchemaCharged = true;
    this.getIconsImages();
    this.defaultCountry = localStorage.getItem(LOCAL_STORAGE.COUNTRY) || "";
    this.goToStart("orderTempForm");
  }

  get fixedFields() {
    const fixedFieldsArray: {
      visible: boolean;
      editable: boolean;
      field: string;
      fieldId: string;
    }[] = [];
    ORDER_CONSTANTS.LIST_FIXED_FIELDS.forEach(field => {
      fixedFieldsArray.push({
        visible: this.orderForm.visibleDashboardFields.includes(field.key),
        editable: this.orderForm.editableDashboardFields.includes(field.key),
        field: field.name,
        fieldId: field.key
      });
    });
    return fixedFieldsArray;
  }

  async getIconsImages() {
    try {
      const iconResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.ICONS
      );
      const imagesResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.IMAGES
      );

      this.iconsList = (iconResponse.data as Icon[]) || ICON_LIST_FIXED;
      this.imagesList = (imagesResponse.data as string[]) || [];
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  confirmDialog(isSave: boolean) {
    if (isSave) {
      this.saveOrderModal();
    } else {
      this.modalTitleOrder = FORM_MESSAGES.CANCEL_MODAL.TITLE;
      this.modalTextOrder = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
      this.modalDialogOrder = true;
    }
  }

  async handleModalAccept() {
    this.modalDialogOrder = false;

    if (this.modalTitleOrder === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.saveOrderTemplate();
    } else if (this.modalTitleOrder === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.$router.go(-1);
    }
  }

  handleModalCancel() {
    this.modalDialogOrder = false;
  }

  handleFieldOrderCancel() {
    this.dialogFieldOrder = false;
    this.indexField = -1;
    this.isEditingOrderField = false;
  }

  createFieldModal(id: string) {
    this.indexField = -1;
    this.isEditingOrderField = false;
    this.dialogFieldOrder = true;

    Utils.moveElement(id, "fieldOrderContainer");
    Utils.scrollToElement(id, this);
  }

  showPreview() {
    this.dialogPreview = true;
    this.clearModel = true;
  }

  closeModalPreview() {
    this.dialogPreview = false;
  }

  saveOrderModal() {
    this.modalTitleOrder = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.modalTextOrder = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.modalDialogOrder = true;
  }

  async saveOrderTemplate() {
    try {
      this.clearFieldListSchema();

      if (!this.orderForm.orderTempRef || !this.orderTemplateEditing)
        throw { message: GENERAL_CONSTANTS.FORBIDDEN };

      this.orderTemplateEditing.uiSetup = {
        multimedia: { _key: this.orderForm.multimediaFile._key },
        helpText: this.orderForm.helpTxt,
        iconUrl: this.orderForm.iconUrl
      };

      this.orderForm.fieldsOrder.forEach(field => (field.default = true));
      this.orderTemplateEditing.fields = this.orderForm.fieldsOrder;
      this.orderTemplateEditing.dashboardVisibleFields = this.buildDashboardVisibleFields();
      this.orderTemplateEditing.dashboardEditableFields = this.buildDashboardEditableFields();

      const responseData = await this.orderService.updateTemplate(
        this.orderForm.orderTempRef,
        this.orderTemplateEditing
      );

      if (responseData.code == Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.load();
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${ORDER_ACCESS.PUT} o ${ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  buildDashboardVisibleFields() {
    const fieldsVisibles = this.orderForm.fieldsOrder.reduce(
      (result: string[], field) => {
        if (field.visibleDashboard) {
          result.push(field.key);
        }
        return result;
      },
      []
    );

    const fieldsVisiblesFixed = this.fixedFields.reduce(
      (result: string[], field) => {
        if (field.visible) {
          result.push(field.fieldId);
        }
        return result;
      },
      []
    );

    return [...fieldsVisibles, ...fieldsVisiblesFixed];
  }

  buildDashboardEditableFields() {
    const fielsEditables = this.orderForm.fieldsOrder.reduce(
      (result: string[], field) => {
        if (field.editableDashboard) {
          result.push(field.key);
        }
        return result;
      },
      []
    );

    const fieldsEditablesFixed = this.fixedFields.reduce(
      (result: string[], field) => {
        if (field.editable) {
          result.push(field.fieldId);
        }
        return result;
      },
      []
    );
    return [...fielsEditables, ...fieldsEditablesFixed];
  }

  async getListData(id: string, name: string) {
    try {
      const responseData = await this.listService.getListById(id);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        responseData.data.options.forEach(option => {
          this.listData[name].data.push(
            option.title as string & { key: string; name: string }
          );
        });
      } else {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  deleteField(field: number) {
    if (this.orderForm.fieldsOrder[field].default) return;

    const foundIndex = this.phoneTypeList.findIndex(
      f => f.slot === `custom-${this.orderForm.fieldsOrder[field].key}`
    );

    if (foundIndex >= 0) {
      this.phoneTypeList.splice(foundIndex, 1);
    }

    this.orderForm.fieldsOrder.splice(field, 1);
    this.saveNewOrder();
    this.loadSchema();
  }

  updateField(field: number, id: string) {
    this.indexField = field;
    this.isEditingOrderField = true;
    this.dialogFieldOrder = true;

    Utils.moveElement(id, "addFieldOrder" + field);
    Utils.scrollToElement(id, this);
  }

  async getTemplate() {
    try {
      const responseData = await this.orderService.getTemplate();

      if (responseData.code == Http.Found && responseData.data !== undefined) {
        this.orderForm.helpTxt = responseData.data.uiSetup.helpText ?? "";
        this.orderForm.multimediaFile = responseData.data.uiSetup
          .multimedia ?? {
          ...MULTIMEDIA_CLEANED
        };

        this.orderForm.iconUrl = responseData.data.uiSetup.iconUrl ?? "";
        this.orderForm.fieldsOrder = responseData.data.fields;
        this.originalFields = [...responseData.data.fields];
        this.orderForm.orderTempRef = responseData.data.key ?? "";
        this.orderTemplateEditing = {
          fields: responseData.data.fields,
          uiSetup: responseData.data.uiSetup
        };
        this.orderForm.visibleDashboardFields =
          (responseData.data.dashboardVisibleFields as string[]) ?? [];
        this.orderForm.editableDashboardFields =
          (responseData.data.dashboardEditableFields as string[]) ?? [];

        await this.getSchema();

        for (const listRef of ORDER_CONSTANTS.DATA_LIST_NAMES) {
          if (responseData.data[listRef as keyof typeof responseData.data])
            await this.getListData(
              responseData.data[
                listRef as keyof typeof responseData.data
              ] as string,
              listRef
            );
        }
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getSchema() {
    try {
      const responseData = await this.orderService.getOrderTempSchema();

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.orderForm.fieldsOrder.forEach(field => {
          if (field.type === "lista") {
            if (field.visualElement === "checkbox") {
              field.schema.items =
                responseData.data?.allOf[0].properties[field.key].items;
            } else {
              field.schema.oneOf =
                responseData.data?.allOf[0].properties[field.key].oneOf;
            }
          }
        });
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  @Watch("fieldsOrder")
  loadSchema() {
    this.orderSchema.required = [];
    this.orderSchema.properties = {};
    this.orderForm.fieldsOrder.map(field => {
      if (field.visible) {
        this;
        Object.assign(this.orderSchema.properties, {
          [field.key]: field.schema
        });
        field.required ? this.orderSchema.required?.push(field.key) : null;
        const exist = this.originalFields.find(f => f.key === field.key);
        if (exist) field.default = true;
      }
    });

    if (this.phoneSchemaCharged) {
      this.getPhoneSchema();
      this.phoneSchemaCharged = false;
    }
  }

  @Watch("orderForm", { deep: true })
  checkEdit() {
    if (this.editComparationStr == "") {
      this.editComparationStr = JSON.stringify(this.orderForm);
    }
    this.invalidEdit =
      JSON.stringify(this.orderForm) === this.editComparationStr;
  }

  getPhoneSchema() {
    const result = this.orderForm.fieldsOrder.filter(
      field => field.type == ORDER_CONSTANTS.PHONE_TYPE
    );

    result.forEach(element => {
      this.phoneTypeList.push({
        slot: `custom-${element.key}`,
        title: element.schema.title,
        model: "",
        countryCode: "",
        countryCallingCode: "",
        required: element.required,
        enabled: element.editable,
        formattedNumber: ""
      });
    });
  }

  saveNewOrder() {
    for (let i = 0; i < this.orderForm.fieldsOrder.length; i++) {
      const field = this.orderForm.fieldsOrder[i];
      field.order = i + 1;
      Vue.set(this.orderForm.fieldsOrder, i, field);
    }
  }

  clearFieldListSchema() {
    this.orderForm.fieldsOrder.forEach(field => {
      if (field.type === TYPE_FIELDS.LIST) {
        delete field.schema.oneOf;
        delete field.schema.items?.enum;
        delete field.schema.items?.oneOf;
      }
    });
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  getSchemaByField(index: number) {
    const schema = {
      type: "object",
      properties: {
        field: {}
      }
    };

    schema.properties.field = this.orderForm.fieldsOrder[index].schema;
    return schema;
  }

  isEditable(fieldName: string): boolean {
    return this.EDITABLE_FIELDS.includes(fieldName);
  }

  createPhoneTypeListTemp(field: FieldGroup) {
    if (field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE) {
      const phoneSchema: PhoneSchema = {
        slot: "field",
        title: field.schema.title,
        countryCode: "",
        countryCallingCode: "",
        required: field.required,
        enabled: field.editable,
        model: "",
        formattedNumber: ""
      };

      return [phoneSchema];
    }
    return [];
  }

  getFile(fileSelected: MultimediaSelected) {
    this.orderForm.multimediaFile = fileSelected;
  }
}
